import { useAuthContext } from 'store';

export const useAuthedUser = () => {
  const { state: authState } = useAuthContext();
  const isAuthed = !!authState?.profile?.id;

  return isAuthed;
};
